import { render, staticRenderFns } from "./AddressProducts.vue?vue&type=template&id=a7c37f24&scoped=true&"
import script from "./AddressProducts.vue?vue&type=script&lang=js&"
export * from "./AddressProducts.vue?vue&type=script&lang=js&"
import style0 from "./AddressProducts.vue?vue&type=style&index=0&id=a7c37f24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c37f24",
  null
  
)

export default component.exports